module.exports = __webpack_public_path__ + "static/media/Jobs_Empty_State.38d2e6ab.png";